import { Component, ElementRef, ViewChild, NgZone } from '@angular/core';
import { ModalsService } from "../../../../../common/src/lib/services/modals.service";

@Component({
  selector: 'app-lead-example',
  templateUrl: './lead-example.component.html',
  styleUrls: ['./lead-example.component.scss']
})
export class LeadExampleComponent {

  @ViewChild('download') download!: ElementRef;

  constructor(
    private modalsService: ModalsService,
    private zone: NgZone
  ) { }

  async close() {
    await this.zone.run(async () => {
      await this.modalsService.close();
    });
  }

  downloadExample() {
    this.download.nativeElement.click();
  }
}
